import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import api from "@/lib/api";

export default function Therapies() {
  const { data: therapies = [], isLoading } = useQuery({
    queryKey: ["therapies"],
    queryFn: () => api.get("/therapies").then((r) => r.data),
  });

  return (
    <div className="mx-auto max-w-6xl px-5 sm:px-8 pt-12">
      <header className="max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-widest text-brand-clay">Therapies</span>
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl text-brand-ink tracking-tight">Ayurvedic therapies</h1>
        <p className="mt-4 text-brand-muted">
          Classical therapies explained clearly — what they involve, how to prepare, and when caution is needed.
        </p>
      </header>

      {isLoading ? (
        <p className="mt-16 text-center text-brand-muted">Loading…</p>
      ) : (
        <div className="mt-10 grid gap-7 sm:grid-cols-2">
          {therapies.map((t, i) => (
            <motion.div
              key={t.slug}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: (i % 2) * 0.08 }}
            >
              <Link to={`/therapies/${t.slug}`} data-testid={`therapy-${t.slug}`} className="group block overflow-hidden rounded-2xl border border-brand-line bg-white shadow-sm transition-transform hover:-translate-y-1">
                <div className="aspect-[16/9] overflow-hidden">
                  <img src={t.image} alt={t.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-1.5 text-xs text-brand-muted">
                    <Clock className="h-3.5 w-3.5" /> {t.duration}
                  </div>
                  <h3 className="mt-2 font-heading text-2xl text-brand-ink group-hover:text-brand">{t.name}</h3>
                  <p className="mt-2 text-sm text-brand-muted">{t.summary}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
